export const Container = { baseStyle: { boxSizing: 'border-box' } };
